import { useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
// 2026-05-10: Toaster component'ı App tree'sine mount edilmemişti → tüm
// toast.error/success çağrıları sessiz kalıyordu (kullanıcı hata mesajı görmüyor).
import { Toaster } from "react-hot-toast";
// Faz BO (2026-05-10): eski Layout.js → yeni AppShell (sidebar refaktörü)
import AppShell from "./components/ui/AppShell";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Categories from "./pages/Categories";
import Orders from "./pages/Orders";
import Users from "./pages/Users";
import PendingUsers from "./pages/PendingUsers";
import Suppliers from "./pages/Suppliers";
import EmailCampaign from "./pages/EmailCampaign";
// Faz E (2026-05-06): Pazar Analizi sayfası — Türkiye plastik ambalaj sektör fotoğrafı,
// rakip analizi, stratejik fırsatlar, fiyat aralıkları, segment analizi.
import PazarAnalizi from "./pages/PazarAnalizi";
import StockManagement from "./pages/StockManagement";
import B2BPricing from "./pages/B2BPricing";
import PushCampaigns from "./pages/PushCampaigns";
import Campaigns from "./pages/Campaigns";
import Reports from "./pages/Reports";
import Quotes from "./pages/Quotes";
import CariHesap from "./pages/CariHesap";
import ImportExport from "./pages/Import";
import Entegrasyonlar from "./pages/Entegrasyonlar";
// Faz 12a (2026-04-29): Audit Log Viewer sayfasi eklendi.
// Tum admin islemleri (login_lockout, ORDER_APPROVED, IMPORT_PRODUCTS, vb.)
// merkezi gorunum + filter + JSON detay modal. Compliance ve operasyonel debug icin.
import AuditLog from "./pages/AuditLog";
// Faz 14b (2026-04-30): Sepeti Terk Hatirlatma raporu sayfasi.
// 24+ saat hareketsiz sepete email gonderim worker'i + recovery rate raporu.
import AbandonedCart from "./pages/AbandonedCart";
// Faz 14a (2026-04-30): Welcome Email Otomasyonu raporu sayfasi.
// 4-adimlik drip-series (kayit, onay, 7g hatirlatma, ilk siparis) funnel raporu.
import WelcomeEmail from "./pages/WelcomeEmail";
// Faz F (2026-05-06): Modern Dashboard + Müşteri 360 — real-time KPI sayfası
import DashboardModern from "./pages/DashboardModern";
import Customer360 from "./pages/Customer360";
// Faz BI (2026-05-10): Sessiz Müşteriler — pasif müşteri uyandırma
import SilentCustomers from "./pages/SilentCustomers";
// Faz G (2026-05-06): Marketing Hub + Settings sayfaları
import MarketingHub from "./pages/MarketingHub";
import Settings from "./pages/Settings";
// Faz I (2026-05-06): NPS Dashboard + Kupon Yönetimi
import NpsDashboard from "./pages/NpsDashboard";
import Coupons from "./pages/Coupons";
// Faz J (2026-05-06): RFM Müşteri Analizi
import RfmAnalysis from "./pages/RfmAnalysis";
// Faz K (2026-05-06): Cross-sell Intelligence
import CrossSell from "./pages/CrossSell";
// Faz L (2026-05-06): Sales Funnel
import SalesFunnel from "./pages/SalesFunnel";
// Faz M (2026-05-06): Action Center (operasyonel uyarı merkezi)
import ActionCenter from "./pages/ActionCenter";
// Faz N (2026-05-06): Forecasting (stok + ciro tahminleme)
import Forecast from "./pages/Forecast";
// Faz P (2026-05-06): Site Trafiği (canlı ziyaretçi takibi)
import SiteTraffic from "./pages/SiteTraffic";
// Faz R (2026-05-06): Cohort & Retention (aylik tutma analizi)
import CohortRetention from "./pages/CohortRetention";
// Faz T (2026-05-06): Customer Journey Map (session bazli yolculuk)
import CustomerJourney from "./pages/CustomerJourney";
// Faz U (2026-05-06): Email Campaign Performance (Brevo webhook)
import EmailPerformance from "./pages/EmailPerformance";
// Faz V (2026-05-06): Sales Pattern Heatmap (saat/gün)
import SalesPattern from "./pages/SalesPattern";
// Faz X (2026-05-06): Mobile Cockpit (owner cebinden tek sayfa)
import Cockpit from "./pages/Cockpit";
// Faz Y (2026-05-06): Category & Brand Sales (kategori marka performansi + sepete eklenen)
import CategorySales from "./pages/CategorySales";
// Faz Z (2026-05-06): Smart Recommendations (proaktif oneri merkezi)
import SmartRecommendations from "./pages/SmartRecommendations";
// Faz AA (2026-05-07): Geographic Analytics (IP -> ulke/sehir)
import GeoAnalytics from "./pages/GeoAnalytics";
// Faz AB (2026-05-07): Product 360 (urun detay tek sayfa)
import Product360 from "./pages/Product360";
// Faz AC (2026-05-07): Drip Campaign Builder (panelden kampanya kurma)
import DripBuilder from "./pages/DripBuilder";
// Faz AD (2026-05-07): System Health + Backup
import SystemHealth from "./pages/SystemHealth";
// Faz AF (2026-05-07): Aylık Hedef + Progress Tracker
import MonthlyGoals from "./pages/MonthlyGoals";
// Faz AK (2026-05-07): WhatsApp Panel
import WhatsAppPanel from "./pages/WhatsAppPanel";
// Faz AM (2026-05-07): Owner Notes / Sticky Memos
import Notes from "./pages/Notes";
// Faz AN (2026-05-07): Subscription / Repeat Order
import Subscriptions from "./pages/Subscriptions";
// Faz AO (2026-05-07): Reviews Moderation
import ReviewsModeration from "./pages/ReviewsModeration";
// Faz AQ (2026-05-07): Returns Moderation
import Returns from "./pages/Returns";
// Faz AT (2026-05-07): Admin User Management + RBAC
import AdminUsers from "./pages/AdminUsers";
// Faz AU (2026-05-07): Bulk Customer CSV Import
import BulkCustomerImport from "./pages/BulkCustomerImport";
// Faz AV (2026-05-07): Bulk Product CSV Upsert
import BulkProductImport from "./pages/BulkProductImport";
// Faz AW (2026-05-07): Stok Manuel Düzeltme
import StockAdjustments from "./pages/StockAdjustments";

const IDLE_TIMEOUT_MS = 15 * 60 * 1000; // 15 dakika
const WARN_BEFORE_MS  =  2 * 60 * 1000; //  2 dakika öncesinde uyar

function IdleGuard({ children }) {
  const navigate = useNavigate();
  const timerRef = useRef(null);
  const warnRef  = useRef(null);
  const [warning, setWarning] = useState(false);

  const logout = () => {
    localStorage.clear();
    setWarning(false);
    navigate("/login");
  };

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    clearTimeout(warnRef.current);
    setWarning(false);
    warnRef.current  = setTimeout(() => setWarning(true),  IDLE_TIMEOUT_MS - WARN_BEFORE_MS);
    timerRef.current = setTimeout(logout, IDLE_TIMEOUT_MS);
  };

  useEffect(() => {
    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];
    events.forEach(e => window.addEventListener(e, resetTimer, { passive: true }));
    resetTimer();
    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      clearTimeout(timerRef.current);
      clearTimeout(warnRef.current);
    };
  }, []); // eslint-disable-line

  return (
    <>
      {warning && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
          background: "#f57c00", color: "#fff", textAlign: "center",
          padding: "10px 16px", fontWeight: 600, fontSize: 14,
          display: "flex", justifyContent: "center", alignItems: "center", gap: 16
        }}>
          ⚠️ Hareketsizlik nedeniyle 2 dakika içinde oturum kapatılacak.
          <button onClick={resetTimer} style={{
            background: "#fff", color: "#f57c00", border: "none",
            borderRadius: 6, padding: "4px 14px", cursor: "pointer", fontWeight: 700
          }}>
            Devam Et
          </button>
        </div>
      )}
      {children}
    </>
  );
}

const PrivateRoute = ({ children }) => {
  if (!localStorage.getItem("token")) return <Navigate to="/login" />;
  return <IdleGuard>{children}</IdleGuard>;
};

export default function App() {
  return (
    <BrowserRouter>
      {/* Global toast container — tüm sayfaların toast.success/error çağrıları buradan render olur */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 5000,
          style: { fontSize: 14, fontWeight: 500 },
          success: { iconTheme: { primary: '#10b981', secondary: '#fff' } },
          error: { duration: 7000, iconTheme: { primary: '#ef4444', secondary: '#fff' } }
        }}
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><AppShell /></PrivateRoute>}>
          <Route index element={<Navigate to="/dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="categories" element={<Categories />} />
          <Route path="orders" element={<Orders />} />
          <Route path="users" element={<Users />} />
          <Route path="pending" element={<PendingUsers />} />
          <Route path="suppliers" element={<Suppliers />} />
          <Route path="email-campaign" element={<EmailCampaign />} />
          <Route path="pazar-analizi" element={<PazarAnalizi />} />
          {/* Faz F: Modern Dashboard + Müşteri 360 */}
          <Route path="dashboard-v2" element={<DashboardModern />} />
          <Route path="customer/:id" element={<Customer360 />} />
          <Route path="silent-customers" element={<SilentCustomers />} />
          {/* Faz G: Marketing Hub + Settings */}
          <Route path="marketing" element={<MarketingHub />} />
          <Route path="settings" element={<Settings />} />
          {/* Faz I: NPS Dashboard + Kupon Yönetimi */}
          <Route path="nps" element={<NpsDashboard />} />
          <Route path="coupons" element={<Coupons />} />
          {/* Faz J: RFM Müşteri Analizi */}
          <Route path="rfm" element={<RfmAnalysis />} />
          {/* Faz K: Cross-sell Intelligence */}
          <Route path="cross-sell" element={<CrossSell />} />
          {/* Faz L: Sales Funnel */}
          <Route path="funnel" element={<SalesFunnel />} />
          {/* Faz M: Action Center */}
          <Route path="action-center" element={<ActionCenter />} />
          {/* Faz N: Forecast */}
          <Route path="forecast" element={<Forecast />} />
          {/* Faz P: Site Trafiği */}
          <Route path="site-traffic" element={<SiteTraffic />} />
          {/* Faz R: Cohort & Retention */}
          <Route path="cohort" element={<CohortRetention />} />
          {/* Faz T: Customer Journey Map */}
          <Route path="journey" element={<CustomerJourney />} />
          {/* Faz U: Email Campaign Performance */}
          <Route path="email-performance" element={<EmailPerformance />} />
          {/* Faz V: Sales Pattern Heatmap */}
          <Route path="sales-pattern" element={<SalesPattern />} />
          {/* Faz X: Mobile Cockpit */}
          <Route path="cockpit" element={<Cockpit />} />
          {/* Faz Y: Category & Brand Sales */}
          <Route path="category-sales" element={<CategorySales />} />
          {/* Faz Z: Smart Recommendations */}
          <Route path="recommendations" element={<SmartRecommendations />} />
          {/* Faz AA: Geographic Analytics */}
          <Route path="geo" element={<GeoAnalytics />} />
          {/* Faz AB: Product 360 — listeden ürün seçimi veya direkt ID */}
          <Route path="product360" element={<Product360 />} />
          <Route path="product360/:id" element={<Product360 />} />
          {/* Faz AC: Drip Campaign Builder */}
          <Route path="drip-builder" element={<DripBuilder />} />
          {/* Faz AD: System Health + Backup */}
          <Route path="system-health" element={<SystemHealth />} />
          {/* Faz AF: Aylık Hedef + Progress Tracker */}
          <Route path="monthly-goals" element={<MonthlyGoals />} />
          {/* Faz AK: WhatsApp Panel */}
          <Route path="whatsapp" element={<WhatsAppPanel />} />
          {/* Faz AM: Owner Notes / Sticky Memos */}
          <Route path="notes" element={<Notes />} />
          {/* Faz AN: Subscription / Repeat Order */}
          <Route path="subscriptions" element={<Subscriptions />} />
          {/* Faz AO: Reviews Moderation */}
          <Route path="reviews" element={<ReviewsModeration />} />
          {/* Faz AQ: Returns Moderation */}
          <Route path="returns" element={<Returns />} />
          {/* Faz AT: Admin User Management + RBAC */}
          <Route path="admin-users" element={<AdminUsers />} />
          {/* Faz AU: Bulk Customer Import */}
          <Route path="bulk-import" element={<BulkCustomerImport />} />
          {/* Faz AV: Bulk Product Import */}
          <Route path="bulk-product-import" element={<BulkProductImport />} />
          {/* Faz AW: Stock Adjustment */}
          <Route path="stock-adjustments" element={<StockAdjustments />} />
          <Route path="stock" element={<StockManagement />} />
          <Route path="b2b-pricing" element={<B2BPricing />} />
          <Route path="push-campaigns" element={<PushCampaigns />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="reports" element={<Reports />} />
          <Route path="quotes" element={<Quotes />} />
          <Route path="cari-hesap" element={<CariHesap />} />
          <Route path="import-export" element={<ImportExport />} />
          <Route path="integrations" element={<Entegrasyonlar />} />
          {/* Faz 12a route — sidebar HistoryIcon ile baglandi */}
          <Route path="audit-log" element={<AuditLog />} />
          {/* Faz 14b route — Sepeti Terk Hatirlatma raporu (sidebar RemoveShoppingCartIcon) */}
          <Route path="abandoned-cart" element={<AbandonedCart />} />
          {/* Faz 14a route — Welcome Email Otomasyonu raporu */}
          <Route path="welcome-email" element={<WelcomeEmail />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}